













































































import { defineComponent, computed, PropType, toRefs } from '@vue/composition-api';
import {
  FullNormalFormData,
  AcoFormData,
  IDENTITY_TYPE_MAP,
  IdentityOptionList,
  DELIVERY_IDENTITY_TYPE_LIST,
  IDENTITY_AVAILABLE_STATUS,
} from '@tt4b/ttam-enums';
import DeliveryTiktokIdentity from './delivery-tiktok-identity/index.vue';
import ErrorTips from '../error-tips/index.vue';
import IdentityInitial from './identity-initial/index.vue';
import UseDeliveryAccount from './use-delivery-account/index.vue';
import CommonTiktokList from '../common-tiktok-list/index.vue';

type ListData = {
  list: IdentityOptionList[] | undefined;
  ttbaList: IdentityOptionList[] | undefined;
  ttbcList: IdentityOptionList[] | undefined;
  page: number;
  hasMore: boolean;
  cursor: number;
};

const name = 'ttam-tag-identity-tiktok-authorize';
export default defineComponent<any>({
  name,
  components: {
    TtamIdentityErrorTips: ErrorTips,
    TtamDeliveryTiktokIdentity: DeliveryTiktokIdentity,
    TtamIdentityInitial: IdentityInitial,
    TtamIdentityUseDeliveryAccount: UseDeliveryAccount,
    TtamIdentityCommonTiktokList: CommonTiktokList,
    // TtamTagIdentityListTips: ListTips,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    isSupportBCNvN: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    creativeData: {
      type: Object as PropType<FullNormalFormData & AcoFormData>,
      default: () => ({}),
    },
    genListOptionsFunction: {
      type: Function,
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      default: () => {},
    },
    listData: {
      type: Object as PropType<ListData>,
      default: () => ({
        list: [],
        page: 1,
        hasMore: true,
        cursor: 0,
      }),
    },
    placeholder: {
      type: String,
      default: '',
    },
    deliveryPlaceholder: {
      type: String,
      default: '',
    },
    isInitial: {
      type: Boolean,
      default: false,
    },
    // 是否展示checkbox组件: 这个变量涉及一些外部的hooks逻辑，所以通过外部传入，避免使用ttam-hooks
    showTagCheckbox: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const { listData, creativeData, disabled, showTagCheckbox } = toRefs(props);

    const list = computed(() => listData.value?.list || []);
    const isListEmpty = computed(() => list.value?.length === 0);
    const isShowError = computed(() => !listData.value?.list);

    const identityType = computed(() => creativeData.value?.identityType);
    const isUseTagBA = computed(() => DELIVERY_IDENTITY_TYPE_LIST.includes(identityType.value));

    const identityAuthId = computed(() => creativeData.value?.identityAuthId || '');
    const identityAuthData = computed(() => creativeData.value?.identityAuthData || {});

    /** 是否禁用UseTagBA checkbox */
    const disabledUseTagBA = computed(() => {
      if (disabled.value || !showTagCheckbox.value) {
        return true;
      }

      const availableStatusList = [IDENTITY_AVAILABLE_STATUS.Available, IDENTITY_AVAILABLE_STATUS.IS_PRIVATE_POST];
      return (
        !availableStatusList.includes(identityAuthData.value?.availableStatus) ||
        !identityAuthData.value?.canUseTagBaVideoList
      );
    });

    const disabledDeliveryList = computed(() => disabled.value || disabledUseTagBA.value);

    const onChangeAuthIdentity = val => {
      emit('change-auth-identity', val);
    };

    /** 绑定TTBA */
    const onLink = () => {
      emit('link');
    };

    const refresh = () => {
      emit('refresh');
    };

    const onIsUseTagBAChange = val => {
      emit('use-tag-ba-change', val);
    };

    const onPopoverCTA = val => {
      emit('popover-click', val);
    };

    const onChangeDeliveryIdentity = val => {
      emit('change-delivery-identity', val);
    };

    const onClickTips = () => {
      emit('click-bottom-tips');
    };

    return {
      name,
      isUseTagBA,
      identityType,
      isShowError,
      isListEmpty,
      identityAuthData,
      disabledUseTagBA,
      identityAuthId,
      IDENTITY_TYPE_MAP,
      disabledDeliveryList,

      onLink,
      refresh,
      onClickTips,
      onChangeAuthIdentity,
      onPopoverCTA,
      onIsUseTagBAChange,
      onChangeDeliveryIdentity,
    };
  },
});
